export default __webpack_public_path__ + "static/media/CS-RaceWeek-Miami(330x330).3785612d.webp";